import { Component, Input, TemplateRef } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "description-modal-wrapper",
  template: `
    <div class="modal-header">
      <h5 class="modal-title">
        <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
      </h5>
      <button (click)="activeModal.close()" class="btn-close text-reset" type="button"></button>
    </div>
    <div class="modal-body">
      <ng-container *ngIf="contentTemplate" [ngTemplateOutlet]="contentTemplate" [ngTemplateOutletContext]="context">
      </ng-container>
    </div>
  `
})
export class DescriptionModalWrapperComponent {
  @Input() contentTemplate: TemplateRef<any>;
  @Input() titleTemplate: TemplateRef<any>;
  @Input() context: any = {};

  constructor(public activeModal: NgbActiveModal) {}
}
